export const CALENDAR_PATH = "/calendar";
